import './style.css';
import { InputField } from '@/components/Exporter';
import SectionWrapper from '../shared/SectionWrapper';

const Security = ({ formHandler }) =>
        <SectionWrapper name="security" icon="mdi:security" >
            <InputField lang="any" isLoading={false} name="password" formHandler={formHandler} type="password" />
            <InputField lang="any" isLoading={false} name="confirmPassword" formHandler={formHandler} type="password" />
        </SectionWrapper>

export default Security;

